import React, { useState } from 'react';
import { Form, FormGroup, Input, Button, Alert, Label } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
// CSS đã được hợp nhất vào App.css

const Login: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values: any) => {
    try {
      setLoading(true);
      console.log('Attempting login with:', values);
      const response = await api.post('/auth/login', values);
      console.log('Login response:', response);
      const data = response.data;

      // Lưu token vào localStorage
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));

      setFeedback({ type: 'success', message: 'Đăng nhập thành công' });
      
      // Điều hướng tùy theo vai trò người dùng
      if (data.user.role === 'staff') {
        navigate('/staff/orders');
      } else {
        navigate('/admin/dashboard');
      }
    } catch (error: any) {
      console.error('Login error:', error);
      console.error('Error response:', error.response);
      setFeedback({ type: 'danger', message: error.response?.data?.message || 'Đăng nhập thất bại' });
    } finally {
      setLoading(false);
    }
  };

  const [formValues, setFormValues] = useState({ username: '', password: '' });
  const [feedback, setFeedback] = useState<{ type: 'success' | 'danger' | null, message?: string }>({ type: null });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormValues(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onFinish(formValues);
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-card-header">
          <h2>Đăng nhập</h2>
        </div>
        <div className="login-card-body">
          {feedback.type && (
            <Alert color={feedback.type} className="mb-3">
              {feedback.message}
            </Alert>
          )}
          <Form onSubmitCapture={handleSubmit} autoComplete="off">
            <FormGroup className="mb-3">
              <Label for="username">Tên đăng nhập</Label>
              <Input
                id="username"
                name="username"
                placeholder="Tên đăng nhập"
                value={formValues.username}
                onChange={handleChange}
                required
              />
            </FormGroup>

            <FormGroup className="mb-4">
              <Label for="password">Mật khẩu</Label>
              <Input
                id="password"
                type="password"
                name="password"
                placeholder="Mật khẩu"
                value={formValues.password}
                onChange={handleChange}
                required
              />
            </FormGroup>

            <Button 
              color="primary"
              type="submit"
              disabled={loading}
              className="w-100 py-2"
            >
              {loading ? (
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              ) : (
                'Đăng nhập'
              )}
            </Button>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Login; 